<!--
	@name common-dialog-flood-risk-report
	@description Common dialog for flood risk report
	@date 2020/02/21
	@license no license
	@copywrite Answers In Retirement Limited
-->

<template>
	<v-dialog v-model="floodRiskReportBox" persistent max-width="1100px">
		<v-toolbar color="blue-grey darken-3" class="px-2" dark>
			<v-toolbar-title> Flood Risk Reports </v-toolbar-title>
			<v-spacer />
			<v-btn id="login-close" icon color="grey darken-1" text :disabled="floodRiskReportSubmitting" @click="floodRiskReportBox = floodRiskReportSubmitting = false">
				<v-icon>mdi-close</v-icon>
			</v-btn>
		</v-toolbar>

		<v-card>
			<v-card-text class="pa-6">
				<p class="text-body-1 mb-5">
					You can now access additional flood data reports based on your customer's postcode. Please note: the partner API service is only currently available for properties based in England. Please use the following links for properties based in <a href="https://naturalresources.wales/splash?orig=/&lang=cy" target="_blank">Wales</a>, <a href="https://beta.sepa.scot/flooding" target="_blank">Scotland</a> and <a href="https://www.nidirect.gov.uk/articles/check-risk-flooding-your-area" target="_blank">Northern Ireland</a>. Select your preferred option(s) below:
				</p>
				<v-container class="pa-0">
					<v-row class="ma-n3">
						<v-col cols="6" md="6">
							<v-card
								class="d-flex flex-column"
								color="grey lighten-2"
								:disabled="loading"
								height="100%"
								hover
								@click="$emit('openFloodReport', 0)"
							>
								<v-system-bar height="16" color="grey lighten-1" />
								<div class="h-100 align-content-center pa-6">
									<v-chip dark label class="teal lighten-1 v-chip-absolute elevation-1">
										UPDATED
									</v-chip>
									<div v-if="loading" class="text-center">
										<p class="text-body-2 mb-3">
											Generating flood report PDF.
											This process can take up to 30 seconds.
											<b>Please do not close the browser.</b>
										</p>
										<v-progress-circular indeterminate />
									</div>
									<div v-else>
										<div class="flex-grow-1 text-center">
											<p class="text-h6 mb-0">
												Flood Map for Planning Report
											</p>
											<p class="text-caption plain font-italic mb-3">
												Opens in new browser window
											</p>
											<p class="text-body-2 mb-0">
												The flood map for planning report is generated via the Environment Agency using their flood map for planning service.
												Please note, the report should be used for guidance purposes only.
											</p>
										</div>
									</div>
								</div>
							</v-card>
						</v-col>
						<v-col cols="6" md="6">
							<v-card
								class="d-flex flex-column"
								color="grey lighten-2"
								height="100%"
								hover
								@click="$emit('openFloodReport', 1)"
							>
								<v-system-bar height="16" color="grey lighten-1" />
								<div class="pa-6">
									<v-scroll-y-transition>
										<div class="flex-grow-1 text-center">
											<p class="text-h6 mb-0">
												Long Term Flood Risk Report
											</p>
											<p class="text-caption plain font-italic mb-3">
												Opens in new browser window
											</p>
											<p class="text-body-2 mb-0">
												This service tells you about an area’s long term risk from rivers and the sea, surface water, reservoirs and groundwater (where data is available).
											</p>
										</div>
									</v-scroll-y-transition>
								</div>
							</v-card>
						</v-col>
					</v-row>
				</v-container>
			</v-card-text>
		</v-card>
	</v-dialog>
</template>

<script>
	export default {
		name: 'common-dialog-flood-risk-report',

		components: {},

        props: {
			loading: { type: Boolean, required: true }
		},

		data() {
			return {
				floodRiskReportBox: false,
				floodRiskReportDialog: undefined,
				floodRiskReportType: false,
				floodRiskReportSubmitting: false
			};
		},

		methods: {
			open() {
				this.floodRiskReportBox = true;
			},

			close() {
				this.floodRiskReportBox = false;
			}
		}
	};
</script>

<style lang="scss" scoped>
	.tile {
		background-color: rgba($success, 0.12);
	}

	.clickable {
		cursor: pointer;
	}

    .v-chip-absolute {
		position: absolute;
		top: -5px;
		left: -5px;
	}
</style>
